export const SHELVES = [
  'Raf 1 — Üst Kat',
  'Raf 1 — Alt Kat',
  'Raf 2 — Üst Kat',
  'Raf 2 — Alt Kat',
];

// Data freshness thresholds (minutes)
export const DATA_THRESHOLDS = {
  FRESH: 3,      // < 3 min: connected
  STALE: 10,     // 3-10 min: stale
  OFFLINE: 10,   // > 10 min: disconnected
} as const;

// Sensor confidence levels
export const CONFIDENCE_LEVELS = {
  HIGH: 80,     // >= 80%: good
  MEDIUM: 50,   // 50-79%: warning
  LOW: 0,       // < 50%: critical
} as const;
